import { get } from 'lodash'

const VERIFY_ACCESS = 'dofe-fo/accessVerification/VERIFY'
const VERIFY_ACCESS_SUCCESS = 'dofe-fo/accessVerification/VERIFY_SUCCESS'
const VERIFY_ACCESS_FAIL = 'dofe-fo/accessVerification/VERIFY_FAIL'

const SEND_VERIFICATION_CODE = 'dofe-fo/accessVerification/SEND_VERIFICATION_CODE'
const SEND_VERIFICATION_CODE_SUCCESS = 'dofe-fo/accessVerification/SEND_VERIFICATION_CODE_SUCCESS'
const SEND_VERIFICATION_CODE_FAIL = 'dofe-fo/accessVerification/SEND_VERIFICATION_CODE_FAIL'

const initialState = {
  verifyAccess: {
    loading: false,
    loaded: false,
    authorized: false
  },
  sendVerificationCode: {
    loading: false,
    loaded: false,
    data: null
  },
  error: null
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case VERIFY_ACCESS:
      return {
        ...state,
        verifyAccess: {
          ...state.verifyAccess,
          loading: true
        }
      }

    case VERIFY_ACCESS_SUCCESS:
      return {
        ...state,
        verifyAccess: {
          ...state.verifyAccess,
          loading: false,
          loaded: true,
          authorized: get(action.result, 'authorized', false),
        },
        error: null
      }

    case VERIFY_ACCESS_FAIL:
      return {
        ...state,
        verifyAccess: {
          ...state.verifyAccess,
          loading: false,
          loaded: false
        },
        error: action.error
      }

    case SEND_VERIFICATION_CODE:
      return {
        ...state,
        sendVerificationCode: {
          ...state.sendVerificationCode,
          loading: true
        }
      }

    case SEND_VERIFICATION_CODE_SUCCESS:
      return {
        ...state,
        sendVerificationCode: {
          ...state.sendVerificationCode,
          loading: false,
          loaded: true,
          data: action.result
        },
        error: null
      }

    case SEND_VERIFICATION_CODE_FAIL:
      return {
        ...state,
        sendVerificationCode: {
          ...state.sendVerificationCode,
          loading: false,
          loaded: false
        },
        error: action.error
      }

    default:
      return state
  }
}

export function verifyAccess(authorizationCode, verificationCode) {
  return {
    types: [
      VERIFY_ACCESS,
      VERIFY_ACCESS_SUCCESS,
      VERIFY_ACCESS_FAIL
    ],
    promise: client =>
      client.post('api/authorization-code/verification-code/verify', {
        data: { authorizationCode, verificationCode }
      })
  }
}

export function sendVerificationCodeToEmail(authorizationCode) {
  return {
    types: [
      SEND_VERIFICATION_CODE,
      SEND_VERIFICATION_CODE_SUCCESS,
      SEND_VERIFICATION_CODE_FAIL
    ],
    promise: client =>
      client.get(`api/authorization-code/verification-code/get?authorizationCode=${authorizationCode}`)
  }
}
